<template>
  <div class="personal-data-container">
    <div class="personal-header">
      <img class="icon1" src="@/assets/images/b1.png" />
      <img class="icon2" src="@/assets/images/b1_1.png" />
      <span>个人信息</span>
    </div>
    <div class="personal-content">
      <el-form
        ref="nameFormRef"
        :model="personalForm"
        label-width="80px"
        :rules="rules"
        class="collapse-form"
        label-position="top"
        size="small"
      >
        <el-form-item label="姓名" prop="employeeName">
          <!-- autofocus -->
          <el-input
            v-model="personalForm.employeeName"
            placeholder="请输入"
            :maxlength="20"
            ref="employeeName"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="cellPhoneNo">
          <el-input
            v-model="personalForm.cellPhoneNo"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="cellPhoneNo != personalForm.cellPhoneNo"
          label="验证码"
          prop="validateCode"
          class="validate-code"
        >
          <el-input
            v-model="personalForm.validateCode"
            :maxlength="6"
            placeholder="请输入"
          ></el-input>
          <el-button
            type="text"
            :disabled="!personalForm.cellPhoneNo"
            @click="startCountdown"
          >
            {{ countdown > 0 ? countdown + "秒" : "发送验证码" }}
          </el-button>
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-select v-model="personalForm.gender" placeholder="请选择">
            <el-option label="男" value="M"></el-option>
            <el-option label="女" value="F"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="生日" prop="birthday">
          <el-date-picker
            v-model="personalForm.birthday"
            placeholder="选择生日"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="职业" prop="career">
          <el-select v-model="personalForm.career" placeholder="请选择">
            <el-option
              v-for="(item, index) in career"
              :key="item + index"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学历" prop="education">
          <el-select v-model="personalForm.education" placeholder="请选择">
            <el-option
              v-for="(item, index) in Education"
              :key="item + index"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业" prop="speciality">
          <el-select v-model="personalForm.speciality" placeholder="请选择">
            <el-option
              v-for="(item, index) in MAJOR"
              :key="item + index"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <div class="footer">
            <el-button type="danger" @click="submitHandle('nameFormRef')"
              >保存信息</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
import { validatPhone, valueToLabel } from "@/utils/index";
import { mapGetters } from "vuex";
export default {
  name: "personalData",
  data() {
    // 使用正则进行验证手机号码
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号码"));
      } else {
        if (!validatPhone.test(value)) {
          callback(new Error("手机号格式错误"));
          return;
        }
        callback();
      }
    };
    const validateBlank = (rule, value, callback) => {
      if (!value || /^\s+$/.test(value)) {
        return callback(new Error(rule.message));
      } else {
        callback();
      }
    };
    return {
      activeNames: [],
      countdown: 0,
      timer: null,
      personalInfo: {},
      educationLabel: "",
      cellPhoneNo: "",
      personalForm: {
        speciality: "",
        career: "",
        gender: "",
        birthday: "",
        employeeName: "",
        education: "",
        cellPhoneNo: "",
        validateCode: "",
      },
      educationList: [],
      rules: {
        //验证表单元素中的规则
        employeeName: [
          {
            required: true,
            validator: validateBlank,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        career: [
          {
            required: true,
            validator: validateBlank,
            message: "请输入职业",
            trigger: "blur",
          },
        ],
        education: [
          { required: true, message: "请选择学历", trigger: "change" },
        ],
        birthday: [
          { required: true, message: "请选择生日", trigger: "change" },
        ],
        speciality: [
          {
            required: true,
            validator: validateBlank,
            message: "请输入专业",
            trigger: "blur",
          },
        ],
        cellPhoneNo: [
          { required: true, validator: validatePhone, trigger: "blur" },
        ],
        validateCode: [
          {
            required: true,
            validator: validateBlank,
            message: "请输入验证码",
            trigger: "blur",
          },
          { pattern: /^\d{6}$/, message: "验证码格式错误", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["exUserInfo", "dicts"]),
    daysInCurrentMonth() {
      const year = this.selectedYear;
      const month = this.selectedMonth;
      if (year && month) {
        return new Date(year, month, 0).getDate();
      }
      return [];
    },
    career() {
      return this.dicts.career || [];
    },
    MAJOR() {
      return this.dicts.MAJOR || [];
    },
    Education() {
      return this.dicts.Education || [];
    },
  },
  mounted() {
    this.getPersonalData();
    this.$store.dispatch("getWideUseDict", "Education");
    this.$store.dispatch("getWideUseDict", "MAJOR");
    this.$store.dispatch("getWideUseDict", "career");
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  watch: {
    countdown: {
      handler(newVal) {
        this.countdown = newVal;
      },
    },
    exUserInfo(newVal) {
      this.personalInfo = newVal;
    },
    $route() {
      // 监听路由变化
      this.activeNames = [];
    },
  },
  methods: {
    startCountdown() {
      if (
        this.personalForm.cellPhoneNo.length === 11 &&
        validatPhone.test(this.personalForm.cellPhoneNo)
      ) {
        this.api("sendBindValidateCode", {
          mobile: this.personalForm.cellPhoneNo,
        }).then((res) => {
          Message({
            message: "发送成功",
            type: "success",
            duration: 1500,
          });
          // 设置计时器
          this.countdown = 60; // 假设验证码有效期为60秒
          this.timer = setInterval(() => {
            if (this.countdown > 0) {
              this.countdown -= 1;
            } else {
              clearInterval(this.timer);
            }
          }, 500);
        });
      }
    },
    getPersonalData() {
      this.api("getCsgUserInformation").then((res) => {
        if (res.result) {
          this.cellPhoneNo = res.result.cellPhoneNo;
          this.personalForm = this.common.clone(res.result);
          this.$store.commit("getExUserInfo", res.result);
          this.resetForm();
          setTimeout(() => {
            this.$refs.employeeName.select();
          }, 300);
        }
      });
    },
    resetForm() {
      this.$refs["nameFormRef"].resetFields();
    },
    submitHandle(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.api("editCsgUserInformation", this.personalForm).then((res) => {
            if (res.result) {
              Message({
                message: "提交成功",
                type: "success",
                duration: 1500,
              });
              this.activeNames = [];
              this.getPersonalData();
              this.resetForm();
            }
          });
        } else {
          Message({
            message: "请正确填写表单",
            type: "warning",
            duration: 1500,
          });
          return false;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.personal-data-container {
  width: 1002px;
  height: 100%;
  border-radius: 10px;
  margin: 20px auto;
  background: rgb(255, 255, 255);
  border-radius: 10px;
  box-shadow: rgba(121, 121, 121, 0.4) 0px 1px 5px 0px;

  .personal-header {
    height: 30px;
    line-height: 30px;
    padding: 30px 80px 20px;
    display: flex;
    align-items: center;
    img {
      height: 24px;
      margin-right: 10px;
    }
    span {
      font-weight: bold;
      position: relative;
      display: inline-block;
      font-size: 18px;
    }
  }
  :deep {
    .el-select-dropdown__item.selected {
      color: #f56c6c;
    }
  }
  ::v-deep {
    .el-select-dropdown__item.selected {
      color: #f56c6c;
    }
    .el-form-item.is-required:not(.is-no-asterisk)
      > .el-form-item__label:before {
      float: right;
      margin-left: 5px;
    }
    .el-form-item__label {
      // color: #6dabf0;
      padding-bottom: 0;
      // font-weight: bold;
      font-size: 16px;
    }
    .el-input__inner {
      background: none;
      border-radius: 0;
      border-width: 0 0 1px 0;
      padding-left: 0;
      font-size: 13px;
    }
  }
  .el-date-editor,
  .el-select {
    width: 100%;
  }

  .personal-content {
    padding: 10px 80px;

    .el-collapse {
      position: relative;
      margin-top: -20px;
      border-top: none;

      .collapse-title {
        width: 20%;
        padding: 0 30px;
        font-size: 16px;
      }

      .collapse-value {
        width: 50%;
        padding: 0 30px;
        font-size: 16px;
      }

      .modify-icon {
        position: absolute;
        right: 30px;
      }

      .collapse-form {
        padding-top: 20px;
        padding-left: 100px;
      }
    }
  }
  .validate-code {
    position: relative;
    .el-button {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  ::v-deep {
    .el-date-editor {
      .el-input__prefix {
        display: none;
      }
    }
  }
  .footer {
    text-align: center;
    padding: 20px 0;
    .el-button {
      width: 130px;
    }
  }
}
</style>
<style lang="scss">
.personal-data-container {
  .personal-header {
    .icon2 {
      display: none;
    }
  }
}
.dark {
  .personal-data-container {
    .personal-header {
      .icon2 {
        display: inline-block;
      }
      .icon1 {
        display: none;
      }
    }
    .el-input__inner {
      color: #fff;
    }
    .el-form-item__label {
      color: #fff;
      opacity: 0.7;
    }
  }

  .pagename-personalData .el-input__inner {
    border-color: #333;
  }
}
body .el-select-dropdown__item.selected {
  color: #f56c6c;
}
</style>
